import OrderService from '@/services/order.service'
export default {
  getListOrder ({ commit }) {
    commit('SET_LOADING_ORDER', true)
    return OrderService.getOrdersByUser()
      .then(order => commit('SET_LIST_ORDER', order.data))
      .catch(error => commit('toast/NEW', { type: 'error', message: error.message }, { root: true }))
  },
  getListCustomStatus ({ commit }) {
    commit('SET_LOADING_ORDER', true)
    return OrderService.getCustomStatuses()
      .then(customStatus => commit('SET_LIST_CUSTOM_STATUS', customStatus.data))
      .catch(() => commit('SET_LIST_CUSTOM_STATUS', []))
  }
}
